export default __webpack_public_path__ + "static/media/013-Empire State Building.e6d53a30.svg";